import axios from 'axios';

const http = axios.create({
    baseURL: 'https://viacep.com.br/ws'
})

export async function getCEP(cep, dispatch) {

    dispatch({ type: 'OPEN_LOADING' })
    await http.get(`/${cep}/json/`,
        {
        }).then(response => {
            sucessoGet(response.data, dispatch)
        }).catch(erro => {
            erroGet(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};


function sucessoGet(response, dispatch) {
    if (!(response.erro)) {
        const endereco = {
            cep: response.cep,
            logradouro: response.logradouro,
            bairro: response.bairro,
            localidade: response.localidade,
            uf: response.uf,
            ibge: response.ibge
        }
        dispatch({ type: 'SET_ENDERECO', endereco: endereco })
    } else {
        dispatch({ type: 'CLEAR_ENDERECO' })
        dispatch({
            type: 'OPEN_ALERT_DIALOG',
            title: 'CEP',
            description: 'Não foi possivel recuperar este CEP, verifique se esta correto ou entre em contato conosto'
        })
    }

}

function erroGet(erro, dispatch) {
    dispatch({ type: 'CLEAR_ENDERECO' })
    dispatch({
        type: 'OPEN_ALERT_DIALOG',
        title: 'CEP',
        description: 'Não foi possivel recuperar este CEP, verifique se esta correto ou entre em contato conosto'
    })
}